import React from 'react'

import { Button, Portlet, Divider, Col, Row } from '_zari/core'

import * as Modals from './modals'

const portletBreadcrumbs = [{ name: 'Perfil' }, { name: 'Seguridad' }]

const SeguridadSection = () => {
  const [mostrarCambioContrasenaModal, setMostrarCambioContrasenaModal] = React.useState(false)

  return (
    <>
      <Portlet>
        <Portlet.Header title='Perfil' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Divider title='Contraseña' />
          <Row>
            <Col md={2}>
              <Button tiny outline color='danger' onClick={() => setMostrarCambioContrasenaModal(true)}>
                Cambiar contraseña
              </Button>
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
      {mostrarCambioContrasenaModal && (
        <Modals.CambiarContrasenaModal
          show={mostrarCambioContrasenaModal}
          handleClose={() => setMostrarCambioContrasenaModal(false)}
        />
      )}
    </>
  )
}

export default React.memo(SeguridadSection)
